import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { breakpoints } = constants;
const { sm, md } = breakpoints.BreakpointNames;

export const rootCss = {
  width: "100%",

  [mediaQuery.downTo(sm)]: {
    maxWidth: "724px",
  },

  [mediaQuery.downTo(md)]: {
    maxWidth: "905px",
  },
};
